export const isNullish = (value?: unknown): value is null | undefined => {
  return (
    value === null ||
    typeof value === 'undefined' ||
    (typeof value === 'number' && Number.isNaN(value))
  )
}

export const isValue = <TValue>(value?: TValue | null): value is TValue => {
  return !isNullish(value)
}
